import React from "react";
import DocumentPreviewPane from "../../common/DocumentPreview/DocumentPreviewPane";

/**
 * QMS thin wrapper around the shared platform DocumentPreviewPane.
 */
function QmsDocumentPreviewPane({
  active = true,
  documentUrl,
  documentExtension,
  documentTitle,
  documentMetadata = null,
  suppressDownloadToolbar = false,
  sourceModule = "QMS",
  sourceTable = "DMS_MyVault_Documents",
  documentId = "",
}) {
  return (
    <DocumentPreviewPane
      active={active}
      sourceModule={sourceModule}
      sourceTable={sourceTable}
      documentId={documentId}
      documentUrl={documentUrl}
      documentExtension={documentExtension}
      documentTitle={documentTitle}
      showDownloadOriginal={!suppressDownloadToolbar}
    />
  );
}

export default QmsDocumentPreviewPane;
